import { type AppState, selectSandbox } from '../../../domain'

import { Usecase } from '../Usecase'

export abstract class BaseSandboxUsecase extends Usecase {
    protected setSandbox (ruleEngine: Partial<AppState['ruleEngineSandbox']>): void {
        this.setState({ ruleEngineSandbox: { ...selectSandbox(this.getState()), ...ruleEngine } })
    }
}
